import { useState } from "react";

import { LineItem } from "@r6digital/rapidstor-types/types/Merchandise";

export default function useCart() {
    const [cart, setCart] = useState<LineItem[]>([]);

    /**
     * Updates the quantity of a line item in the cart.
     * If it is a default selected item, the quantity is set to 0 and it has removed text, it will return the line item.
     * The line item returned will be used to display the product removal modal.
     * 
     * @param id 
     * @param quantity 
     * 
     * @returns LineItem | boolean
     */
    const updateCartQuantity = (id: string, quantity: number): LineItem | false => {
        const lineItem = cart.find((item) => item._id === id);

        if (!lineItem) {
            return false;
        }

        const newCart = cart.map((item) => {
            if (item._id === id) {
                return { ...item, quantity };
            }
            return item;
        });

        setCart(newCart);

        if (quantity === 0 && lineItem.defaultSelected && lineItem.removedText) {
            return lineItem;
        }    

        return false;
    }

    const initiateCart = (cart: LineItem[]) => {
        setCart(cart);
    }

    return {
        cart,
        initiateCart,
        updateCartQuantity
    }
}